import api from "../services/api";
import globalToast from "../components/common/globalToast";

const service_path = '/quotes.php';
const sub_service_path = '/quotes-notifications.php';
const messages_path = '/quote-messages.php';

export function getQuotes(filters = {}) {
    // Remove filtros vazios antes de enviar
    const cleanFilters = Object.entries(filters).reduce((acc, [key, value]) => {
        if (value !== '' && value !== null && value !== undefined) {
            acc[key] = value;
        }
        return acc;
    }, {});

    const params = new URLSearchParams(cleanFilters).toString();
    const url = params ? `${service_path}?${params}` : service_path;
    
    const response = api.get(url);

    return response;
};

export function getQuotesNotifications() {

    const response = api.get(sub_service_path);

    return response;
};

export function getQuoteDetails(id) {

    const response = api.get(`${service_path}?id=${id}`);

    return response;
};

export function getQuoteMessages(quoteId) {

    return api.get(`${messages_path}?quote_id=${quoteId}`);
};

export function postQuoteMessage(payload) {

    return api.post(messages_path, payload);
};

export function completeQuote(id) {

    return api.patch(service_path, { id, complete: true });
};

export function updateQuote(data, navigateBack) {

    api.patch(service_path, data)
        .then(response => {

            const { data } = response;

            if (data.success) {
                globalToast.success("Orçamento editado com sucesso!");
                navigateBack();
            } else {
                globalToast.error(data.message);
            };
        })
        .catch(error => {
            console.log(error);
            globalToast.error('Houve um erro ao executar essa ação!');
        });
};

export function postQuoteAnser(data, navigateBack) {

    api.post(service_path, data)
        .then(response => {

            const { data } = response;

            if (data.success) {
                globalToast.success("Resposta do orçamento enviada com sucesso!");
                navigateBack();
            } else {
                globalToast.error(data.message);
            };
        })
        .catch(error => {
            console.log(error);
            globalToast.error('Houve um erro ao enviar a resposta do orçamento!');
        });
};